export default {
  getOnlineStatus: state => state.onlineStatus,
  getCurrentCoordinates: state => state.currentCoordinates
}
